module.exports = __webpack_public_path__ + "img/left_video1.7d0d80e0.png";